import { isString, isInstanceOf, nopString, nopMap } from '../common/mod.js';
import { flatClone } from '../util/mod.js';
const JSON_MTYPE = /application\/json/i;
const TEXT_MTYPE = /(?:(?:text\/\w+)|(?:application\/(?:javascript|xhtml\+xml))|(?:image\/svg\+xml))/i;
export class DefaultHttpClient {
    options;
    decodeBody(reply) {
        const contentType = reply.headers.get('Content-Type') ?? nopString;
        if (JSON_MTYPE.test(contentType)) {
            return reply.json();
        }
        else if (TEXT_MTYPE.test(contentType)) {
            return reply.text();
        }
        else {
            return reply.arrayBuffer();
        }
    }
    async requestHandler(url, data, options) {
        if (data) {
            options.headers = flatClone(options.headers);
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(data);
        }
        if (this.options.baseUrl && (isString(url) || isInstanceOf(url, URL))) {
            url = new URL(url, this.options.baseUrl);
        }
        if (this.options.credentialsPolicy) {
            options.credentials = this.options.credentialsPolicy;
        }
        const reply = await fetch(url, options);
        if (!reply.ok) {
            const error = await this.decodeBody(reply);
            if (this.options.errorAdapter) {
                throw this.options.errorAdapter(error);
            }
            else if (error.message) {
                throw new Error(error.message);
            }
            else {
                throw new Error(`${options?.method || 'GET'} ${reply.url} ${reply.status}`);
            }
        }
        return options.asRawResponse ? reply : this.decodeBody(reply);
    }
    constructor(options = nopMap) {
        this.options = options;
    }
    head(url, options) {
        const clone = flatClone(options);
        clone.method = 'HEAD';
        clone.asRawResponse = true;
        return this.requestHandler(url, null, clone);
    }
    get(url, options) {
        (options = flatClone(options)).method = 'GET';
        return this.requestHandler(url, null, options);
    }
    patch(url, data, options) {
        (options = flatClone(options)).method = 'PATCH';
        return this.requestHandler(url, data, options);
    }
    post(url, data, options) {
        (options = flatClone(options)).method = 'POST';
        return this.requestHandler(url, data, options);
    }
    put(url, data, options) {
        (options = flatClone(options)).method = 'PUT';
        return this.requestHandler(url, data, options);
    }
    delete(url, data, options) {
        (options = flatClone(options)).method = 'DELETE';
        return this.requestHandler(url, data, options);
    }
}
//# sourceMappingURL=_default_http_client.js.map